<script setup lang="ts">
import MeinePlanungsgeschaefteUnauth from '@/components/MeinePlanungsgeschaefteUnauth.vue';
import MeinePlanungsgeschaefteAuth from '@/components/MeinePlanungsgeschaefteAuth.vue';
import { isAuthenticated } from '@/helpers/globals';

const authenticated = isAuthenticated();
</script>
<template>
    <div v-if="authenticated">
        <MeinePlanungsgeschaefteAuth />
    </div>
    <div v-else>
        <MeinePlanungsgeschaefteUnauth />
    </div>
</template>
